module.exports = __webpack_public_path__ + "img/logo-apolar-imoveis-high.b919f736.webp";